export default "/assets/images/problem-solved-03.50559e8767cf9d87.webp";